import React, { useState, useEffect } from "react";
import BaseUrl from "../../../constants/BaseUrl";
import { useSelector } from "react-redux";
import moment from "moment";
import BroadCastPopup from "../../popup/broadCastDetailPopup";
import NoData from "../../reusebale/noData"

const BroadcastCarousel = ({ broadCastPage }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [data, setData] = useState([]);
  const [showDetailPopup, setDetailPopup] = useState(false);
  const [detailData, setDetailData] = useState("");
  const { loginSuccess } = useSelector((state) => state.auth);

  const GetAllBroadcast = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}api/broadcast/getBroadcastByTenantId/${loginSuccess.user._id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setData(result.data);
        }
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    GetAllBroadcast();
  }, []);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === data.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? data.length - 1 : prevIndex - 1
    );
  };

  const isShowDetail = (item) => {
    setDetailData(item);
    setDetailPopup(true);
  };

  const onHandleClose = () => {
    setDetailPopup(false);
  };

  return (
    <div className="max-w-3xl mx-auto mt-5 px-5 py-4 bg-white rounded-lg">
      {/* Header */}
      <div className="flex justify-between items-center mb-5">
        <h2 className="text-lg font-popinsSemiBold text-darkColor">
          Broadcasts
        </h2>
        <button
          className="text-themeColor hover:underline font-popinsSemiBold text-xs"
          onClick={broadCastPage}
        >
          View All
        </button>
      </div>

      {/* Slider Container */}
      <div className="relative overflow-hidden h-44 bg-[#FAF2EC] rounded-lg">
        <div
          className="flex transition-transform duration-500 ease-in-out"
          style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        >
          {data?.map((broadcast) => (
            <div
              key={broadcast.id}
              className="min-w-full p-4 flex flex-col justify-center cursor-pointer"
              onClick={() => {
                isShowDetail(broadcast);
              }}
            >
              <h3 className="text-md font-popinsSemiBold text-darkColor leading-tight">
                {broadcast?.title}
              </h3>
              <p className="text-darkColor/40 text-xs mt-2 font-popinsRegular">
                {moment(broadcast?.createdAt).format("MM/DD/YYYY, h:mm A")}
              </p>
              <p className="text-sm mt-3 leading-relaxed font-popinsRegular text-darkColor line-clamp-3">
                {broadcast?.description}
              </p>
            </div>
          ))}

          {data.length === 0 && (
            <div className="w-full flex items-center">
              <NoData />
            </div>
          )}
        </div>
      </div>

      {/* Navigation */}
      <div className="flex justify-center mt-4 space-x-8 text-sm">
        <button
          onClick={prevSlide}
          className="text-gray-400 hover:text-gray-700 font-popinsMedium"
        >
          Previous
        </button>
        <button
          onClick={nextSlide}
          className="text-[#0381CA] hover:text-themeColor  font-popinsMedium"
        >
          Next
        </button>
      </div>
      {showDetailPopup && (
        <BroadCastPopup detailData={detailData} onBack={onHandleClose} />
      )}
    </div>
  );
};

export default BroadcastCarousel;
